import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.182 6.903h-2.785V4.894c0-.753.456-.93.777-.93h1.964V.644L11.43.634c-3.006 0-3.692 2.473-3.692 4.057v2.213H6v3.42h1.738V20h3.656v-9.678h2.467l.32-3.42z" fill="#000" /></svg>;